import Request from 'components/Request';
import { gameTypeClick } from 'react/redux/actions/matchSelection';
import { setActiveSearchType } from 'react/redux/actions/matchmaking';
import { AUTO_MATCH_ONLY } from 'react/matchmaking/findMatch/findMatchModes';

export const DOUBLES_PARTY_RECEIVED = 'DOUBLES_PARTY_RECEIVED';
export const DOUBLES_PARTY_LEAVING = 'DOUBLES_PARTY_LEAVING';
export const DOUBLES_PARTY_LEAVE_FAILED = 'DOUBLES_PARTY_LEAVE_FAILED';
export const DOUBLES_PARTY_NOTICE_DISMISSED = 'DOUBLES_PARTY_NOTICE_DISMISSED';

const RANKED_DOUBLES_GAME_COUNT = 3;

// A party from an API response or the doubles_party socket message, or null.
export const doublesPartyReceived = (party) => ({ type: DOUBLES_PARTY_RECEIVED, payload: party || null });

export const doublesPartyNoticeDismissed = () => ({ type: DOUBLES_PARTY_NOTICE_DISMISSED });

// Resolves with the party the server sends back; rejects with the server
// response (its responseJSON.error is the message to show).
const partyRequest = (action, parameters) => (dispatch) => Promise.resolve(Request.apiv1Post(`doubles_party/${action}`, parameters))
	.then((response) => {
		const party = (response && response.doubles_party) || null;
		dispatch(doublesPartyReceived(party));
		return party;
	});

export const invitePartner = (partnerId, ladderId) => partyRequest('invite', { partner_id: partnerId, ladder_id: ladderId });

export const acceptPartyInvite = (partyId) => partyRequest('accept', { party_id: partyId });

// Declining and leaving are the player's own doing, so the party ending gives
// them no notice, whichever of the response and the socket message comes first.
const leavingRequest = (action, partyId) => (dispatch) => {
	dispatch({ type: DOUBLES_PARTY_LEAVING, payload: partyId });
	return dispatch(partyRequest(action, { party_id: partyId }))
		.catch((failure) => {
			dispatch({ type: DOUBLES_PARTY_LEAVE_FAILED, payload: partyId });
			throw failure;
		});
};

export const declinePartyInvite = (partyId) => leavingRequest('decline', partyId);

// Either member; cancels a pending invite and ends the party's search.
export const leaveParty = (partyId) => leavingRequest('leave', partyId);

/**
 * The leader of a ready party starts its ranked 2v2 search: Best of 3, found
 * automatically, on the party's ladder. onRefused receives the refused
 * searches, as with startModeSearch.
 */
export const startRankedDoublesSearch = (ladderId, onRefused = null) => (dispatch) => {
	dispatch(setActiveSearchType('ranked'));
	const playOption = {
		ladderId,
		teamSize: 2,
		isRanked: true,
		gameCount: RANKED_DOUBLES_GAME_COUNT,
		queueVisibilityType: AUTO_MATCH_ONLY,
	};
	return dispatch(gameTypeClick([playOption], null, AUTO_MATCH_ONLY, onRefused));
};
